import buildQrPayload from './buildQrPayload';
import { QrConfig } from './types';
import utf8ByteString from './utf8ByteString';

import type { Options } from 'qr-code-styling';

export type QrRenderType = 'canvas' | 'svg';

/**
 * Maps our framework-agnostic QrConfig onto the qr-code-styling Options object.
 * Kept pure (no rendering) so the mapping can be unit-tested.
 */
export default function buildQrCodeOptions(config: QrConfig, renderType: QrRenderType = 'canvas'): Options {
  const { style, size } = config;

  const options: Options = {
    type: renderType,
    width: size,
    height: size,
    margin: style.margin,
    data: utf8ByteString(buildQrPayload(config.content)),
    qrOptions: { errorCorrectionLevel: style.errorCorrection },
    dotsOptions: { color: style.foreground, type: style.dotStyle },
    backgroundOptions: { color: style.background },
    cornersSquareOptions: { color: style.foreground, type: style.cornerSquareStyle },
    cornersDotOptions: { color: style.foreground, type: style.cornerDotStyle },
  };

  if (style.logoDataUrl) {
    options.image = style.logoDataUrl;
    options.imageOptions = {
      imageSize: style.logoSize ?? 0.3,
      margin: 4,
      hideBackgroundDots: true,
      // The logo is an inline data: URL. qr-code-styling's default behaviour
      // fetches it to a blob, which the storefront CSP (connect-src) blocks for
      // data: URIs, leaving the QR blank. Draw the <img> directly instead — the
      // image is same-origin so the canvas isn't tainted and export still works.
      saveAsBlob: false,
    };
  }

  return options;
}
